<template>
  <v-container>
    <!--    Heading-->
    <v-row>
      <v-col md="4" sm="12" class="primary--text">
        <h4 class="title mb-2">Timeless {{ $route.name }}</h4>
      </v-col>

      <v-col md="4" sm="12"></v-col>
    </v-row>

    <!-- Search -->
    <v-row class="justify-end">
      <v-col md="4" sm="12">
        <v-text-field
          rounded
          filled
          flat
          placeholder="Search"
          v-model="search"
          class="search"
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Actions   -->
    <v-row
      class="d-flex flex-column justify-start flex-md-row justify-md-between align-md-center mb-6"
    >
      <v-col cols="6">
        <v-form class="">
          <v-row no-gutters>
            <v-col>
              <AddDriver />
              <UpdateDriver />
            </v-col>
            <v-col>
              <WarningModal
                :handleCancel="handleCancel"
                :handleConfirm="handleConfirm"
                v-if="$store.getters['Dashboard/showWarningModal']"
              />

              <SuccessModal
                v-if="$store.getters['Dashboard/showSuccessModal']"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-col>

      <v-col md-4 class="d-flex justify-start justify-md-end align-center">
        <download-csv
          class="btn btn-default"
          :data="drivers"
          name="drivers.csv"
        >
          <v-icon
            medium
            color="dark-gray  darken-2"
            style="padding: 10px; background: lightgray; border-radius:50%; cursor: pointer"
          >
            mdi-export
          </v-icon>
          <span class="ml-2">Download CSV</span>
        </download-csv>
      </v-col>
    </v-row>

    <!--    Page-->
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="filteredDrivers"
          show-select
          dense
        >
          <template v-slot:item.profile_photo_path="{ item }">
            <v-avatar class="ma-2">
              <img :src="item.profile_photo_path" :alt="item.first_name" />
            </v-avatar>
          </template>
          <template v-slot:item.driving_licence="{ item }">
            <a
              class="text-decoration-none"
              target="_blank"
              rel="noopener noreferrer"
              :href="item.driving_licence"
            >
              <v-icon
                color="primary"
                small
                class="mr-2"
                v-if="item.driving_licence"
              >
                mdi-export
              </v-icon>
              <p v-else>N/A</p>
            </a>
          </template>
          <template v-slot:item.good_conduct_doc="{ item }">
            <a
              class="text-decoration-none"
              target="_blank"
              rel="noopener noreferrer"
              :href="item.good_conduct_doc"
            >
              <v-icon
                color="primary"
                small
                class="mr-2"
                v-if="item.good_conduct_doc"
              >
                mdi-export
              </v-icon>
              <p v-else>N/A</p>
            </a>
          </template>

          <template v-slot:item.verified="{ item }">
            <span>{{ verificationStatus(item.verified) }}</span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="mr-2" v-bind="attrs" v-on="on">
                  mdi-dots-vertical
                </v-icon>
              </template>

              <v-list>
                <v-list-item style="cursor: pointer" @click="open(item)">
                  <v-list-item-title class="d-flex flex-row align-center">
                    <v-icon style="font-size: 1.2rem" color="secondary"
                      >mdi-eye</v-icon
                    >
                    <span class="d-block">View</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  style="cursor: pointer"
                  @click="handleUpdate(item)"
                >
                  <v-list-item-title class="d-flex flex-row align-center">
                    <v-icon style="font-size: 1.2rem" color="primary"
                      >mdi-pencil</v-icon
                    >
                    <span class="d-block">Edit</span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AddDriver from "@/components/Dashboard/Drivers/AddDriver";
import UpdateDriver from "@/components/Dashboard/Drivers/UpdateDriver";
import WarningModal from "@/components/Dashboard/Modals/WarningModal";
import SuccessModal from "@/components/Dashboard/Modals/SuccessModal";
export default {
  name: "Drivers",
  components: {
    AddDriver,
    WarningModal,
    SuccessModal,
    UpdateDriver
  },
  data: () => ({
    headers: [
      { text: "", align: "start", value: "profile_photo_path" },
      { text: "ID", align: "start", value: "id" },
      { text: "Driver Name", align: "start", value: "name" },
      { text: "Email Address", value: "email" },
      { text: "Contact No", value: "phone_number" },
      { text: "Driving License", value: "driving_licence" },
      { text: "Good Conduct Cert", value: "good_conduct_doc" },
      { text: "Route", value: "area_of_operation" },
      { text: "Status", value: "verified" },
      { text: "Actions", value: "actions", sortable: false }
    ],

    // Search
    search: "",

    // For modal
    driverName: "",
    driverEmail: ""
  }),

  methods: {
    open: function(driver) {
      this.$router.push({ name: "Driver", params: { driver } });
    },
    handleDelete(driver) {
      const modalDescription = `Are you sure you want to delete driver ${driver.name}, an Email will be sent to ${driver.email} to notify them of they deletion`;
      const modalText = "Press confirm to continue with deletion";
      this.$store.dispatch("Dashboard/setModalDescription", modalDescription);
      this.$store.dispatch("Dashboard/setModalText", modalText);
      this.driverName = driver.name;
      this.driverEmail = driver.email;
      this.$store.dispatch("Dashboard/showWarningModal");
    },
    handleConfirm() {
      this.$store.dispatch("Dashboard/hideWarningModal");
      const modalDescription = `Driver ${this.driverName} has been successfully deleted`;
      const modalText = `An email sent to ${this.driverEmail} to notify them of they deletion`;
      this.$store.dispatch("Dashboard/setModalDescription", modalDescription);
      this.$store.dispatch("Dashboard/setModalText", modalText);
      this.$store.dispatch("Dashboard/showSuccessModal");
    },

    handleCancel() {
      this.$store.dispatch("Dashboard/hideWarningModal");
    },

    handleUpdate(driver) {
      this.$store.dispatch("Dashboard/setUpdateDriver", driver);
      this.$store.dispatch("Dashboard/showDriverUpdateModal");
    },

    verificationStatus(el) {
      return el === 1 ? "Verified" : "Unverified";
    }
  },

  computed: {
    drivers() {
      return this.$store.getters["Dashboard/drivers"];
    },

    filteredDrivers() {
      return this.drivers.filter(driver => {
        return driver.name.toLowerCase().match(this.search.toLowerCase());
      });
    }
  },

  created() {
    this.$store.dispatch("Dashboard/fetchDrivers");
  }
};
</script>

<style>
.text-uppercase {
  color: darkslategray;
  font-weight: 600;
}

.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outlined > .v-input__control > .v-input__slot {
  align-items: stretch;
  min-height: 40px !important;
}

.v-text-field--full-width .v-input__prepend-outer,
.v-text-field--full-width .v-input__prepend-inner,
.v-text-field--full-width .v-input__append-inner,
.v-text-field--full-width .v-input__append-outer,
.v-text-field--enclosed .v-input__prepend-outer,
.v-text-field--enclosed .v-input__prepend-inner,
.v-text-field--enclosed .v-input__append-inner,
.v-text-field--enclosed .v-input__append-outer {
  margin-top: 9px;
}

.theme--light.search > .v-input__control > .v-input__slot {
  background: white !important;
  border: 1px solid lightgray !important;
}

.v-dialog {
  border-radius: 2rem !important;
  margin: 0px !important;
  overflow-y: auto;
}
</style>
